<template>
  <div class="props-flow">
    <div class="nav">
      <div class="top">
        <van-sticky>
          <NavBar
            ref="navBar"
            :goBack="goBack"
            :title="$t('propsFlow.道具流水')"
          ></NavBar>
        </van-sticky>
      </div>
    </div>
    <div class="form-content">
      <van-form @submit="onSubmit">
        <div class="field-item">
          <span class="label"
            ><span class="red">* </span>{{ $t("propsFlow.选择日期") }}：</span
          >
          <van-field
            v-model="form.date"
            readonly
            clickable
            class="select-field"
            :name="$t('propsFlow.选择日期')"
            :placeholder="$t('propsFlow.点击选择日期')"
            @click="handleChooseTime"
            :rules="[
              {
                required: true,
                message: $t('propsFlow.请选择日期'),
              },
            ]"
          >
          </van-field>
        </div>
        <div v-if="is_classify" class="field-item">
          <span class="label"
            ><span class="red">* </span>{{ $t("propsFlow.道具分类") }}：</span
          >
          <van-field
            v-model="form.category.name"
            readonly
            clickable
            :name="$t('propsFlow.道具分类')"
            :placeholder="$t('propsFlow.点击选择道具分类')"
            @click="handleChooseCate"
            :rules="[
              {
                required: true,
                message: $t('propsFlow.请选择道具分类'),
              },
            ]"
          >
          </van-field>
        </div>
        <div class="field-item">
          <span class="label">{{ $t("propsFlow.道具名称") }}：</span>
          <van-field
            v-model="form.name"
            class="input-field"
            :name="$t('propsFlow.道具名称')"
            :placeholder="$t('propsFlow.请输入道具名称')"
          />
        </div>

        <div style="margin: 16px">
          <van-button
            class="submit-btn"
            :loading="confirmLoading"
            block
            type="primary"
            size="large"
            native-type="submit"
          >
            {{ isShowTimer ? timeNumber : $t("propsFlow.查询") }}
          </van-button>
        </div>
      </van-form>
    </div>

    <div v-if="resultVisible">
      <van-row type="flex" class="header">
        <van-col span="6">{{ $t("propsFlow.时间") }}</van-col>
        <van-col span="6">{{ $t("propsFlow.道具") }}</van-col>
        <van-col span="6">{{ $t("propsFlow.变化") }}</van-col>
        <van-col span="6">{{ $t("propsFlow.原因") }}</van-col>
      </van-row>
      <van-row type="flex" v-for="(item, index) in flowData" :key="index">
        <van-col span="6" v-if="game_id == 126">
          {{ otherTimeFilter(item.time) }}
        </van-col>
        <van-col span="6" v-else>
          {{ item.time | timeFilter("MM/DD HH:mm") }}
        </van-col>
        <van-col span="6">
          {{ item.prop_name || item.name }}
        </van-col>
        <van-col span="6">
          {{ item.change }}
        </van-col>
        <van-col span="6">
          {{ item.remark }}
        </van-col>
      </van-row>
      <van-row type="flex">
        <van-col span="24">
          {{
            `${$t("propsFlow.只能单天查询")}${days}${$t(
              "propsFlow.天的相应数据",
            )}`
          }}
        </van-col>
      </van-row>
    </div>
    <van-popup v-model="showTimeVisible" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="onConfirm"
        @cancel="showTimeVisible = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        @confirm="onClassConfirm"
        :loading="pickerLoading"
        @cancel="
          showPicker = false;
          keyword = '';
        "
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('propsFlow.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>

    <VerifiedModal v-model="verifiedPopup" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import storage from "@/utils/storage";
import { apiGetPropsFlow, apiGetPropCategory } from "@/api/user";
// const PinyinEngine = require('pinyin-engine');
import { mapState } from "vuex";
export default {
  name: "PropsFlow",
  data() {
    return {
      confirmLoading: false,
      showTimeVisible: false,
      resultVisible: false,
      pickerLoading: false,
      showPicker: false,
      currentDate: dayjs().toDate(),
      game_id: storage.getGameId(),
      flowData: [],
      form: {
        date: dayjs().format("YYYY-MM-DD"),
        name: "",
        category: {
          name: "",
          id: "",
        },
      },
      isShowTimer: false,
      timeNumber: 0,
      timer: null,
      columns: [],
      // 是否需要分类
      is_classify: false,
      days: 7,
      keyword: "",
      roleList: [],
      currentRoleId: "",
      verifiedPopup: false,
    };
  },
  filters: {},
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  computed: {
    // calRoleList () {
    //   if (this.roleList && this.roleList.length) {
    //     const arr = this.roleList.map(item => ({ text: `${item.role_name}(${item.server_name})`, value: item.role_id }));
    //     arr.push({ text: '+$t('添加新角色''), value: 'add' });
    //     return arr;
    //   } else {
    //     return [{ text: $t('请选择角色'), value: 'no_role' }, { text: '+$t('添加新角色''), value: 'add' }];
    //   }
    // },
    ...mapState({
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.text && item.text.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
    otherTimeFilter() {
      return (val) => {
        return val
          ? dayjs(val).format(
              `MM${this.$t("propsFlow.月")}DD${this.$t("propsFlow.日")} HH:mm`,
            )
          : "";
      };
    },
    is_verified() {
      const { is_verified } = this.$route.query;
      return this.defaultRoleInfo.is_verified === 0 && is_verified == 1;
    },
  },
  created() {
    const { game_id, is_classify, days } = this.$route.query;
    // if (game_id) {
    //   sessionStorage.setItem('game_id', Number(game_id));
    // }
    if (is_classify) {
      this.is_classify = true;
      this.getCategory();
    }
    if (days) {
      this.days = days || 7;
    }

    if (this.is_verified) {
      this.verifiedPopup = true;
    }
    // this.getSdkRoleList();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    // getSdkRoleList () {
    //   getSdkRoleList().then(res => {
    //     if (res.code === 0) {
    //       this.roleList = res.data;
    //       if (res.data && res.data.length) {
    //         this.currentRoleId = res.data[0].role_id;
    //       } else {
    //         this.currentRoleId = 'no_role';
    //       }
    //     } else {
    //       this.currentRoleId = 'no_role';
    //     }
    //   }).catch(() => {
    //     this.currentRoleId = 'no_role';
    //   });
    // },
    // handleDropDown (value) {
    //   const token = storage.getItem('token');
    //   const fullPath = this.$route.fullPath;
    //   if (!token) {
    //     this.$router.replace({
    //       name: 'Login',
    //       query: {
    //         redirect: fullPath
    //       }
    //     });
    //     return;
    //   }
    //   if (value === 'add') {
    //     this.$router.push({
    //       name: 'BindRoles',
    //       query: {
    //         is_auth: 1
    //       }
    //     });
    //   } else {
    //     this.currentRoleId = value;
    //   }
    // },
    getCategory() {
      this.pickerLoading = true;
      apiGetPropCategory()
        .then((res) => {
          if (res.code === 0) {
            this.columns =
              res.data &&
              res.data.map((item) => ({
                text: item.name,
                value: item.id,
              }));
            // this.pinyinEngine = new PinyinEngine(this.columns, ['text']);
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },
    onSubmit() {
      if (this.isShowTimer) {
        return;
      }
      if (!this.defaultRoleInfo.role_id) {
        this.$toast(this.$t("propsFlow.请选择角色"));
        return;
      }
      const { session_id } = this.$route.query;

      // const curRoleInfo = this.roleList.find(item => item.role_id === this.currentRoleId);
      const params = {
        date: this.form.date,
        name: this.form.name,
        role: this.defaultRoleInfo.role_id,
        server_id: this.defaultRoleInfo.f_id,
        session_id: session_id ? Number(session_id) : undefined,
      };
      if (this.is_classify) {
        params.category_id = this.form.category.id + "";
      }
      this.confirmLoading = true;
      apiGetPropsFlow(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "props_flow",
              game_id: storage.getGameId(),
              role: this.defaultRoleInfo.role_id,
              server_id: this.defaultRoleInfo.f_id,
            });
            this.flowData = res.data;
            this.isShowTimer = true;
            this.resultVisible = true;
            this.timeNumber = 60;
            this.timer = setInterval(() => {
              this.timeNumber -= 1;
              if (this.timeNumber === 0) {
                this.clearTimer();
                return;
              }
            }, 1000);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    clearTimer() {
      this.isShowTimer = false;
      this.timeNumber = 0;
      clearInterval(this.timer);
    },
    handleChooseTime() {
      this.showTimeVisible = true;
    },
    onConfirm(data) {
      this.showTimeVisible = false;
      this.form.date = dayjs(data).format("YYYY-MM-DD");
    },
    handleChooseCate() {
      this.showPicker = true;
    },
    onClassConfirm(data) {
      this.form.category.name = data.text;
      this.form.category.id = data.value;
      this.showPicker = false;
    },
  },
};
</script>

<style lang="less" scoped>
.props-flow {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  .nav {
    flex: 0 0 auto;
    .choose-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 44px;
      padding: 0 10px;
      box-sizing: border-box;
      border-bottom: 1px solid #f7f7f7;
      background-color: #fff;
      .label {
        color: #242424;
        font-size: 15px;
      }
    }
    .history {
      display: flex;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
}
/deep/ .van-search {
  padding: 0;
}
/deep/ .van-row {
  color: #646566;
  background-color: #fff;
  &.header {
    color: #000;
    font-size: 14px;
  }
  .van-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 4px;
    border-bottom: 1px solid #ebedf0;
  }
}
</style>
